import Vue from "vue";

// 只缓存浏览器加载结果，不改写角色、剧本或快照。每个地址每页只探测一次。
const state = Vue.observable({ failed: Object.create(null) });
const checked = new Set();
export const imageNameKey = name =>
  typeof name === "string" ? name.normalize("NFC").trim() : "";
export const markImageFailed = source => {
  if (typeof source === "string" && source) Vue.set(state.failed, source, true);
};
const probe = source => {
  if (checked.has(source) || typeof Image === "undefined") return;
  checked.add(source);
  const image = new Image();
  image.onload = () => { image.onload = image.onerror = null; };
  image.onerror = () => {
    markImageFailed(source);
    image.onload = image.onerror = null;
  };
  image.src = source;
};

// CSS背景没有error事件；共享响应式探针使所有使用该地址的界面同步回退。
// 后备图片也失败时继续往后走，去重地址避免递归/重复请求。
export const imageWithFallback = (...sources) => {
  for (const source of new Set(sources)) {
    if (typeof source !== "string" || !source || state.failed[source]) continue;
    probe(source);
    return source;
  }
  return "";
};
